<template>
<div>
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-button style="margin-bottom:5px;" @click="addPakage()" type="primary">新增套餐</el-button>
    </el-col>
    <el-table v-loading="listLoading" :data="tableData" style="width: 100%" class="info">
        <el-table-column sortable prop="code" label="套餐编号" min-width="100px">
        </el-table-column>
        <el-table-column sortable prop="name" label="套餐名称" min-width="180px">
        </el-table-column>
        <el-table-column prop="type" label="套餐类型" min-width="180px" sortable>
        </el-table-column>
        <!-- <el-table-column
            prop="price"
            label="套餐价格(元)"
             min-width="150px"
             sortable>
            </el-table-column> -->
        <el-table-column prop="gprsSize" label="流量套餐(MB)" min-width="180px" sortable>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150px">
            <template scope="scope">
                <el-button @click="handleClick(scope.$index, scope.row)" size="small">编辑</el-button>
                <el-button @click="delPakage(scope.$index, scope.row)" type="danger" size="small">删除</el-button>

            </template>
        </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar" style="text-align:right">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totals">
        </el-pagination>
    </el-col>
    <!--新增套餐-->
    <el-dialog title="新增套餐" :visible.sync="userInfoFormVisible" :close-on-click-modal="true">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="套餐编号" prop="code">
                <el-input v-model="ruleForm.code"></el-input>
            </el-form-item>
            <el-form-item label="套餐名称" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="套餐类型" prop="type">
                <el-select v-model="ruleForm.type" style="width:100%"  @change='typeChange(ruleForm.type)'>
                    <el-option label="请选择类型" value="请选择"></el-option>
                    <el-option label="月卡" value="月卡"></el-option>
                    <el-option label="年卡" value="年卡"></el-option>
                    <el-option label="叠加卡" value="叠加卡"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐价格(元)" prop="price" v-show="priceVisible">
                <el-input-number v-model="ruleForm.price" :min="1" :max="5000" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item label="流量套餐(MB)" prop="gprsSize">
                <el-input-number v-model="ruleForm.gprsSize" :min="0" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item label="流量阀值(MB)" prop="flowLimit" v-show="flowLimitVisible">
                <el-input-number v-model="ruleForm.flowLimit" :min="0" style="width:100%"></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right" class="dialog-footer">
            <el-button @click.native="close()">取消</el-button>
            <el-button type="primary" @click.native="addPackageAction('ruleForm')">{{save}}</el-button>
        </div>
    </el-dialog>

    <!--修改套餐-->
    <el-dialog title="编辑套餐" :visible.sync="updatepackage" :close-on-click-modal="true">
        <el-form :model="editPackageForm" :rules="rules" ref="editPackageForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="套餐编号">
                <el-input v-model="editPackageForm.code" :disabled="myDisable.codeDis"></el-input>
            </el-form-item>
            <el-form-item label="套餐名称" prop="name">
                <el-input v-model="editPackageForm.name"></el-input>
            </el-form-item>
            <el-form-item label="套餐类型">
                <el-select v-model="editPackageForm.type" :disabled="myDisable.typeDis" @change='updateTypeChange(editPackageForm.type)' style="width:100%">
                    <el-option label="请选择类型" value="请选择"></el-option>
                    <el-option label="月卡" value="月卡"></el-option>
                    <el-option label="年卡" value="年卡"></el-option>
                    <el-option label="叠加卡" value="叠加卡"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐价格(元)" prop="price" v-show="updatePriceVisible">
                <el-input-number v-model="editPackageForm.price" :min="1" :max="5000" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item label="流量套餐(MB)">
                <el-input-number v-model="editPackageForm.gprsSize" :min="0" style="width:100%" :disabled="myDisable.gprsDis"></el-input-number>
            </el-form-item>
            <el-form-item label="流量阀值(MB)" v-show="updateFlowLimitVisible">
                <el-input-number v-model="editPackageForm.flowLimit" :min="0" style="width:100%"></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right" class="dialog-footer">
            <el-button @click.native="close()">取消</el-button>
            <el-button type="primary" @click.native="editPackageAction('editPackageForm')">{{save}}</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
//导入api
import util from '../../common/js/util'
import constant from '../../common/js/constant'
import {
    getPackListPage,
    savePakage,
    delPakageById,
    getCode
} from '../../api/api'
export default {
    data() {
        //检查套餐编号
        var validateCode = (rule, value, callback) => {
            var reg = /^[0-9]*[1-9][0-9]*$/;
            if (!value) {
                return callback(new Error('套餐编号不能为空'));
            } else {
                callback();
            }
        }
        //检查是否选择了类型
        var validateType = (rule, value, callback) => {
            if (value === '请选择') {
                return callback(new Error('请选择套餐类型'));
            } else {
                callback();
            }
        }
        //检查价格
        var validatePrice = (rule, value, callback) => {
            var reg = /^[0-9]*[1-9][0-9]*$/;
            if (!reg.test(value)) {
                return callback(new Error('请输入整数'));
            } else {
                callback();
            }
        }
        //检查输入的流量单位
        var validateGprsSize = (rule, value, callback) => {
            var reg = /^(0|\+?[1-9][0-9]*)$/;
            if (!reg.test(value)) {
                return callback(new Error('请输入整数'));
            } else {
                callback();
            }
        }
        return {
            //弹窗显示状态
            title: '',
            userInfoFormVisible: false,
            priceVisible: false,
            updatePriceVisible: false,
            updatepackage: false,
            flowLimitVisible:true,
            updateFlowLimitVisible:true,
            currentPage: 1, //当前页
            totals: 1, //总数据条数
            tableData: [], //数据
            pageSize: 10,
            listLoading: false,
            myDisable: { //输入框禁用状态控制
                codeDis: false,
                typeDis: false,
                gprsDis: false,

            },
            //
            type: false,
            save: '保存',
            ruleForm: {
                code: '',
                name: '',
                price:null,
                gprsSize: null,
                flowLimit:null,
                type: '请选择',
                updateStatus: 0 //0表示添加
            },
            editPackageForm: {
                code: '',
                name: '',
                price:null,
                gprsSize: null,
                flowLimit:null,
                type: '请选择',
                updateStatus: 1 //1表示更新
            },
            rules: {
                //自定义检查规则
                code: [{
                    validator: validateCode,
                    trigger: 'blur'
                }],
                name: [{
                        required: true,
                        message: '套餐名称不能为空',
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 50,
                        message: '长度在 2 到 50 个字符',
                        trigger: 'blur'
                    }
                ],
                type: [{
                    validator: validateType,
                    trigger: 'change'
                }],
                price:[{validator: validatePrice, trigger: 'change' }],
                gprsSize: [{
                    validator: validateGprsSize,
                    trigger: 'change'
                }]
            }
        }
    },
    mounted() {
        //默认查询数据
        this.getlist();
    },

    methods: {
        handleClick(index, row) {
            //修改数据
            this.updatepackage = true;
            this.editPackageForm.code = row.code;
            this.editPackageForm.name = row.name;
            this.editPackageForm.type = row.type;
            this.editPackageForm.gprsSize = row.gprsSize;
            this.editPackageForm.price=row.price;
            this.editPackageForm.updateStatus = 1;
            this.editPackageForm.flowLimit = row.flowLimit;
            if('叠加卡' == this.editPackageForm.type){
                this.updatePriceVisible = true;
                this.updateFlowLimitVisible = false;
            }
            //禁用对应的输入框 
            this.myDisable.codeDis = true;
            //this.myDisable.typeDis=true;
            //this.myDisable.gprsDis=true;
        },
        getlist() {
            //参数列表
            this.listLoading = true;
            let param = {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            };
            getPackListPage(param).then((res) => {
                this.tableData = res.data.list;
                this.totals = res.data.total;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getlist();
        },
        handleCurrentChange(val) {
            //分页查询
            this.currentPage = val;
            this.getlist();
        },
        typeChange(val){
            if('叠加卡' == val){
                this.priceVisible = true;
                this.flowLimitVisible = false;
                this.ruleForm.flowLimit = null;
                this.ruleForm.price = 1;
            }else{
                this.priceVisible = false;
                this.flowLimitVisible = true;
                this.ruleForm.flowLimit = 0;
                this.ruleForm.price = null;
            }
        },
        updateTypeChange(val){
            if('叠加卡' == val){
                this.updatePriceVisible = true;
                this.updateFlowLimitVisible = false;
                this.editPackageForm.flowLimit = null;
                this.editPackageForm.price = 1;
            }else{
                this.updatePriceVisible = false;
                this.updateFlowLimitVisible = true;
                this.editPackageForm.flowLimit = 0;
                this.editPackageForm.price = null;
            }
        },
        addPakage() {
            //添加套餐
            //清空输入框
            this.userInfoFormVisible = true;
            this.ruleForm.updateStatus = 0;
            this.ruleForm.code = "";
            this.ruleForm.name = "";
            this.ruleForm.type = "请选择";
            this.ruleForm.gprsSize = null;
            //  this.ruleForm.price=1;
            //打开禁用项
            //this.myDisable.codeDis=false;
            //this.myDisable.typeDis=false;
            //this.myDisable.gprsDis=false;
        },
        addPackageAction(addPackageForm) {
            this.$refs[addPackageForm].validate((valid) => {
                if (valid) {
                    if(this.ruleForm.type == '叠加卡'){
                        this.ruleForm.flowLimit = undefined;
                    }else{
                        this.ruleForm.price = undefined;
                    }
                    var param = this.ruleForm;
                    savePakage(param).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                            });
                            this.userInfoFormVisible = false;
                            this.updatepackage = false;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                        this.getlist();
                    });
                }
            });
        },
        editPackageAction(editPackageForm) {
            this.$refs[editPackageForm].validate((valid) => {
                if (valid) {
                    if(this.editPackageForm.type == '叠加卡'){
                        this.editPackageForm.flowLimit = undefined;
                    }else{
                        this.editPackageForm.price = undefined;
                    }
                    var param = this.editPackageForm;
                    savePakage(param).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                            });
                            this.userInfoFormVisible = false;
                            this.updatepackage = false;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                        this.getlist();
                    });
                }
            });
        },
        resetForm(formName) {
            //还原输入框
            this.$refs[formName].resetFields();
        },
        close() {
            this.userInfoFormVisible = false;
            this.updatepackage = false;
        },
        delPakage(index, value) {
            //删除套餐
            this.$confirm('您将删除指定套餐, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var param = {
                    code: value.code,
                };
                delPakageById(param).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.getlist();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// tao_can.vue?3aa9010e